// extracted by mini-css-extract-plugin
export default {"logo":"SauceLogo__logo__XKz32"};